import type { Contract, Deal } from "../types";

export const contractPaymentTypeChoices = [
  {
    id: "subscription",
    name: "resources.contracts.payment_types.subscription",
  },
  { id: "installment", name: "resources.contracts.payment_types.installment" },
  { id: "one_time", name: "resources.contracts.payment_types.one_time" },
];

export const contractStatusChoices = [
  { id: "active", name: "resources.contracts.statuses.active" },
  { id: "completed", name: "resources.contracts.statuses.completed" },
  { id: "overdue", name: "resources.contracts.statuses.overdue" },
  { id: "cancelled", name: "resources.contracts.statuses.cancelled" },
];

export const buildContractDefaultsFromDeal = (
  deal: Pick<Deal, "id" | "name" | "company_id" | "contact_ids" | "amount">,
  today = new Date(),
): Partial<Contract> => {
  const date = today.toISOString().slice(0, 10);

  return {
    title: deal.name,
    deal_id: deal.id,
    company_id: deal.company_id,
    contact_id: deal.contact_ids?.[0] ?? null,
    payment_type: "one_time",
    total_amount: deal.amount ?? 0,
    monthly_amount: null,
    start_date: date,
    status: "active",
    next_payment_date: date,
    payment_schedule: {},
  };
};
